var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50065 14.2666C9.2451 14.5221 8.92843 14.6499 8.55065 14.6499C8.17287 14.6499 7.85621 14.5221 7.60065 14.2666L1.73398 8.39992C1.61176 8.2777 1.51454 8.13325 1.44232 7.96659C1.3701 7.79992 1.33398 7.62214 1.33398 7.43325V2.66659C1.33398 2.29992 1.46454 1.98603 1.72565 1.72492C1.98676 1.46381 2.30065 1.33325 2.66732 1.33325H7.43398C7.62287 1.33325 7.80065 1.36936 7.96732 1.44159C8.13398 1.51381 8.27843 1.61103 8.40065 1.73325L14.2673 7.61659C14.5229 7.87214 14.6507 8.18603 14.6507 8.55825C14.6507 8.93047 14.5229 9.24436 14.2673 9.49992L9.50065 14.2666ZM4.33398 5.33325C4.61176 5.33325 4.84787 5.23603 5.04232 5.04159C5.23676 4.84714 5.33398 4.61103 5.33398 4.33325C5.33398 4.05547 5.23676 3.81936 5.04232 3.62492C4.84787 3.43047 4.61176 3.33325 4.33398 3.33325C4.05621 3.33325 3.8201 3.43047 3.62565 3.62492C3.43121 3.81936 3.33398 4.05547 3.33398 4.33325C3.33398 4.61103 3.43121 4.84714 3.62565 5.04159C3.8201 5.23603 4.05621 5.33325 4.33398 5.33325Z",
    fill: "#097E07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountTag);
export default __webpack_public_path__ + "static/media/DiscountTag.c7052855bbebfb80c5234a2c2933103e.svg";
export { ForwardRef as ReactComponent };